module.exports = __webpack_public_path__ + "img/racecourse-durbanville-turf-1800.645bc3d3.svg";